module.exports = __webpack_public_path__ + "img/gear.9ffcad.svg";